import styled from "styled-components";

export const SelectStyled = styled.div`

   .MuiSelect-select {
        display: flex;
    }
        
`;

export const EmptyText = styled("h3")<{ color?: string }>`
  padding: 1rem 1rem;
  border-radius: 4px;
  text-align: center;
  margin: 0 auto;
  font-size: 1rem;
  margin-top: 30px;
  font-weight: bold;
  color: ${(p) => p.color || "#959595"};

  .highlighted {
    font-weight: 600;
    color: initial;
  }
`;